export function getFileIcon(fileName: string): string {
  const extension = fileName.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'xbrl':
    case 'xbri':
      return 'bi-filetype-xml';
    case 'zip':
      return 'bi-file-earmark-zip';
    case 'jpg':
    case 'jpeg':
      return 'bi-filetype-jpg';
    case 'aac':
    case 'ai':
    case 'bmp':
    case 'cs':
    case 'css':
    case 'csv':
    case 'doc':
    case 'docx':
    case 'exe':
    case 'gif':
    case 'heic':
    case 'html':
    case 'java':
    case 'js':
    case 'json':
    case 'jsx':
    case 'key':
    case 'm4p':
    case 'md':
    case 'mdx':
    case 'mov':
    case 'mp3':
    case 'mp4':
    case 'otf':
    case 'pdf':
    case 'php':
    case 'png':
    case 'ppt':
    case 'pptx':
    case 'psd':
    case 'py':
    case 'raw':
    case 'rb':
    case 'sass':
    case 'scss':
    case 'sh':
    case 'svg':
    case 'tiff':
    case 'tsx':
    case 'ttf':
    case 'txt':
    case 'wav':
    case 'woff':
    case 'xls':
    case 'xlsx':
    case 'xml':
    case 'yml':
      return 'bi-filetype-' + extension;
    default:
      return 'bi bi-file-earmark';
  }
}
